import { useState } from 'react';
import { NotifyPlaceSelection } from '../../../../types';
import { ClientOption, NotifyDeptList } from './NotifyDeptTreeSelect';
import { SVG } from '../../../../../../../../constants/assetLists';
import { Checkbox } from '@mui/material';
import { ANNOUNCEMENT_TYPES } from '../../../../../../../operations/components/Modals/AddAnnouncement/data';

const Collapse = ({
  in: open,
  onToggle,
  children,
  headerText,
}: {
  in: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  headerText: string;
}) => {
  return (
    <div className={`px-4 pt-2 ${open ? '' : 'border-b border-gray80 pb-2'}`}>
      <div className="flex items-center gap-2">
        <img
          onClick={onToggle}
          src={SVG.lessThanGrayIcon}
          alt=""
          className={`w-2 h-3 object-contain cursor-pointer transition-transform ${open ? '-rotate-90' : ''}`}
        />
        <p className="text-xl select-none">{headerText}</p>
      </div>
      <div
        className={`transition-max-height duration-300 ease-in-out overflow-hidden ${open ? '' : 'max-h-0'}`}
      >
        {children}
      </div>
    </div>
  );
};

type PersonalNotifPanelProps = {
  clients: ClientOption[];
  notifyFromDepts: NotifyPlaceSelection[];
  onFromDeptsChange: (val: NotifyPlaceSelection[]) => void;
  notifyQuickDepts: NotifyPlaceSelection[];
  onQuickDeptsChange: (val: NotifyPlaceSelection[]) => void;
  notifyTypes: string[];
  onTypesChange: (val: string[]) => void;
  onBackPress: () => void;
  containerWrapperClassName?: string;
};

function PersonalNotifPanel({
  clients,
  notifyFromDepts,
  onFromDeptsChange,
  notifyQuickDepts,
  onQuickDeptsChange,
  notifyTypes,
  onTypesChange,
  onBackPress,
  containerWrapperClassName = 'flex-1 flex flex-col gap-4 extraSmall:min-h-[500px] lg:min-h-[530px] 2xl:min-h-[600px] extraSmall:max-h-[500px] lg:max-h-[530px] 2xl:max-h-[600px] overflow-y-auto px-[40px]',
}: PersonalNotifPanelProps) {
  const [expandFrom, setExpandFrom] = useState(true);
  const [expandQuick, setExpandQuick] = useState(true);
  const [expandTypes, setExpandTypes] = useState(true);

  return (
    <div className={containerWrapperClassName}>
      <div className="flex items-center gap-2 border-b border-deepAqua pb-2 px-4">
        <img
          src={SVG.downArrowBlackIcon}
          alt="Back"
          onClick={onBackPress}
          className="cursor-pointer -rotate-90 w-3 h-3"
        />
        <p className="text-xl">קבלת התראות - הגדרות אישית</p>
      </div>
      <Collapse
        in={expandFrom}
        onToggle={() => setExpandFrom((p) => !p)}
        headerText="מקבל התראות של מחלקות"
      >
        <NotifyDeptList
          clients={clients}
          value={notifyFromDepts}
          onChange={onFromDeptsChange}
          headerTextStyles="text-xl"
        />
      </Collapse>

      <Collapse
        in={expandQuick}
        onToggle={() => setExpandQuick((p) => !p)}
        headerText="יעד הודעות מהירות"
      >
        <NotifyDeptList
          clients={clients}
          value={notifyQuickDepts}
          onChange={onQuickDeptsChange}
          headerTextStyles="text-xl"
        />
      </Collapse>

      <Collapse
        in={expandTypes}
        onToggle={() => setExpandTypes((p) => !p)}
        headerText="מקבל התראות מסוג"
      >
        <div className="p-3 grid grid-cols-1 gap-1">
          {ANNOUNCEMENT_TYPES.map((type) => {
            const isChecked = notifyTypes.includes(type.value);

            const handleToggle = () => {
              onTypesChange(
                isChecked
                  ? notifyTypes.filter((t) => t !== type.value)
                  : [...notifyTypes, type.value],
              );
            };

            return (
              <div
                key={type.value}
                onClick={handleToggle}
                className={`flex items-center gap-2.5 px-2 py-1 rounded cursor-pointer transition-colors duration-200 ${
                  isChecked ? 'bg-gray90' : 'hover:bg-gray95'
                }`}
              >
                <Checkbox
                  size="small"
                  sx={{ p: 0.5 }}
                  color="secondary"
                  checked={isChecked}
                  onChange={handleToggle}
                  onClick={(e) => e.stopPropagation()} // prevents double toggle
                />

                <div className="flex items-center gap-2">
                  <img
                    src={type.icon}
                    alt=""
                    className="w-5 h-5 object-contain"
                  />
                  <span className="text-base">{type.title}</span>
                </div>
              </div>
            );
          })}
        </div>
      </Collapse>
    </div>
  );
}
export default PersonalNotifPanel;
